import { useMemo } from "react";
import { BooleanFormatter, TextFormatter } from "../muiTableHelper";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { ContentCopyOutlined, DeleteOutline } from "@mui/icons-material";

export const AccountsListColumns = ({
  setEditData,
  setShowModal,
  deleteData,
  cloneData,
}) => {
  return useMemo(
    () => [
      {
        accessorKey: "actions",
        header: "Actions",
        size: 140,
        Cell: ({ row }) => {
          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setEditData(row.original);
                  setShowModal(true);
                }}
              >
                <EditIcon />
              </IconButton>
              {row.original.apGroup && (
                <>
                  <IconButton
                    variant="contained"
                    color="warning"
                    onClick={() => {
                      deleteData(row.original);
                    }}
                  >
                    <DeleteOutline />
                  </IconButton>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      cloneData(row.original);
                    }}
                  >
                    <ContentCopyOutlined />
                  </IconButton>
                </>
              )}
            </>
          );
        },
      },
      {
        accessorKey: "name",
        header: "Name",
        enableSorting: true,
        sortingFn: "alphanumeric",
        size: 300,
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.name,
          });
        },
      },
      {
        accessorKey: "apOrder",
        header: "Order",
        enableSorting: true,
        sortingFn: "alphanumeric",
        size: 150,
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.apOrder,
          });
        },
      },
      {
        accessorKey: "active",
        header: "Active",
        size: 120,
        Cell: ({ row }) => {
          return BooleanFormatter({ bool: row.original.active });
        },
      },
      {
        accessorKey: "export",
        size: 120,
        header: "Export",
        Cell: ({ row }) => {
          return BooleanFormatter({ bool: row.original.export });
        },
      },
      {
        accessorKey: "display",
        header: "Display",
        size: 120,
        Cell: ({ row }) => {
          return BooleanFormatter({ bool: row.original.display });
        },
      },
      {
        accessorKey: "apGroup",
        header: "Group",
        size: 120,
        Cell: ({ row }) => {
          return BooleanFormatter({ bool: row.original.apGroup });
        },
      },
      {
        accessorKey: "accountNumber",
        header: "Account Number",
        enableSorting: true,
        sortingFn: "alphanumeric",
        size: 200,
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.accountNumber,
          });
        },
      },
    ],
    [setEditData, setShowModal, deleteData, cloneData],
  );
};
